import { render, staticRenderFns } from "./QueueGroup.vue?vue&type=template&id=351dde8e&"
import script from "./QueueGroup.vue?vue&type=script&lang=js&"
export * from "./QueueGroup.vue?vue&type=script&lang=js&"
import style0 from "./QueueGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports